/* ============================= */
/* VERSION V1.2 - BLOC SEO LOCAL */
/* Google Maps SEO + Tracking GA4 */
/* ============================= */

import React from "react";
import "../styles/SeoLocal.css";
import { trackEvent } from "../utils/analytics";

const SeoLocal = () => {
  return (
    <section className="seoLocal" aria-labelledby="seoLocal-title">
      <div className="seoLocal__container">
        <header className="seoLocal__header">
          <h2 id="seoLocal-title" className="seoLocal__title">
            Taxi à Belfort — Service premium
          </h2>

          <p className="seoLocal__subtitle">
            Gare • Aéroport • Longue distance • Business —{" "}
            <strong>7j/7 sur réservation</strong>
          </p>

          {/* SEO discret */}
          <span className="sr-only">
            Taxi Belfort : gare de Belfort, aéroport Bâle-Mulhouse, transferts,
            longue distance, réservation taxi rapide par téléphone ou WhatsApp.
          </span>
        </header>

        <div className="seoLocal__grid">
          <div className="seoLocal__card">
            <h3 className="seoLocal__cardTitle">Zones & transferts</h3>
            <p className="seoLocal__text">
              Départs et arrivées autour de <strong>Belfort</strong> et{" "}
              <strong>Buc (90800)</strong>, avec transferts vers la{" "}
              <strong>gare de Belfort</strong> et l’
              <strong>aéroport Bâle-Mulhouse</strong>. Longue distance possible
              sur demande.
            </p>

            <p className="seoLocal__text">
              Nous desservons également <strong>Montbéliard</strong>,{" "}
              <strong>Mulhouse</strong> et les trajets régionaux selon vos
              besoins.
            </p>
          </div>

          <div className="seoLocal__card">
            <h3 className="seoLocal__cardTitle">Réservation rapide</h3>

            <p className="seoLocal__text">
              Un message suffit : indiquez l’heure, le lieu de départ, la
              destination et le nombre de passagers. Je vous confirme
              rapidement.
            </p>

            <div className="seoLocal__actions">
              <a
                className="seoLocal__btn seoLocal__btnGold"
                href="tel:+33749424919"
                onClick={() =>
                  trackEvent("click_call", {
                    event_category: "contact",
                    event_label: "seolocal_call",
                    value: 1,
                  })
                }
              >
                📞 Appeler
              </a>

              <a
                className="seoLocal__btn seoLocal__btnGhost"
                href="https://wa.me/33749424919"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackEvent("click_whatsapp", {
                    event_category: "contact",
                    event_label: "seolocal_whatsapp",
                    value: 1,
                  })
                }
              >
                💬 WhatsApp
              </a>

              <a
                className="seoLocal__btn seoLocal__btnGhost"
                href="#reservation"
                onClick={() =>
                  trackEvent("click_reservation", {
                    event_category: "engagement",
                    event_label: "seolocal_reservation",
                    value: 1,
                  })
                }
              >
                🚖 Pré-réservation
              </a>

              <a
                className="seoLocal__btn seoLocal__btnGhost"
                href="https://www.google.com/maps/search/?api=1&query=Belfort"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackEvent("click_maps", {
                    event_category: "local_seo",
                    event_label: "seolocal_maps_belfort",
                    value: 1,
                  })
                }
              >
                📍 Google Maps
              </a>
            </div>
          </div>
        </div>

        {/* mini FAQ SEO */}
        <div className="seoLocal__faq" aria-label="Questions fréquentes">
          <div className="seoLocal__faqItem">
            <h4>Vous faites les transferts gare et aéroport ?</h4>
            <p>
              Oui : gare de Belfort, aéroport Bâle-Mulhouse, et autres
              destinations sur demande.
            </p>
          </div>

          <div className="seoLocal__faqItem">
            <h4>Comment réserver ?</h4>
            <p>
              Par téléphone, WhatsApp ou via la pré-réservation sur le site.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SeoLocal;
